export const accountStatusKeys = {
  all: ["accountStatuses"] as const,
  lists: () => [...accountStatusKeys.all, "list"] as const,
}
export const statusReasonKeys = {
  all: ["statusReasons"] as const,
  lists: () => [...statusReasonKeys.all, "list"] as const,
}
export const orderStatusKeys = {
  all: ["orderStatuses"] as const,
  lists: () => [...orderStatusKeys.all, "list"] as const,
}
export const orderStatusReasonsKeys = {
  all: ["orderStatusReasons"] as const,
  lists: () => [...orderStatusReasonsKeys.all, "list"] as const,
}
export const revenueClassesKeys = {
  all: ["revenueClasses"] as const,
  lists: () => [...revenueClassesKeys.all, "list"] as const,
}
export const salesLocationsKeys = {
  all: ["salesLocations"] as const,
  lists: () => [...salesLocationsKeys.all, "list"] as const,
}
export const stateKeys = {
  all: ["states"] as const,
  lists: () => [...stateKeys.all, "list"] as const,
}

export const contactTypesKeys = {
  all: ["contactTypes"] as const,
  lists: () => [...contactTypesKeys.all, "list"] as const,
}
export const contactLanguagesKeys = {
  all: ["contactLanguages"] as const,
  lists: () => [...contactLanguagesKeys.all, "list"] as const,
}

export const phoneNumberTypesKeys = {
  all: ["phoneNumberTypes"] as const,
  lists: () => [...phoneNumberTypesKeys.all, "list"] as const,
}

export const contactDispositionsKeys = {
  all: ["contactDispositionsKeys"] as const,
  lists: () => [...contactDispositionsKeys.all, "list"] as const,
}

export const defaultDispositionsKeys = {
  all: ["defaultDispositions"] as const,
  lists: () => [...defaultDispositionsKeys.all, "list"] as const,
}

export const resubmitDispositionsKeys = {
  all: ["resubmitDispositions"] as const,
  lists: () => [...resubmitDispositionsKeys.all, "list"] as const,
}

export const rejectStatusKeys = {
  all: ["rejectStatus"] as const,
  lists: () => [...rejectStatusKeys.all, "list"] as const,
}

export const businessTitlesKeys = {
  all: ["businessTitles"] as const,
  lists: () => [...businessTitlesKeys.all, "list"] as const,
}

export const accountHolderRelationshipKeys = {
  all: ["accountHolderRelationship"] as const,
  lists: () => [...accountHolderRelationshipKeys.all, "list"] as const,
}

export const caseAssignmentGroupsKeys = {
  all: ["caseAssignmentGroups"] as const,
  lists: () => [...caseAssignmentGroupsKeys.all, "list"] as const,
}
